/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Email/Emails/Content/Email/Related/Content/Popup/Content/Persons/Person/Relation/Empty"
  
}) {
  return null
}